var _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessibility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#0C6FF3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 28.5,
    stroke: "#fff",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.148 19.5a4.75 4.75 0 100-9.5 4.75 4.75 0 000 9.5zm9.427 26.41a2.25 2.25 0 11-4.092 1.874l-5.028-10.98-5.029 10.98a2.25 2.25 0 11-4.091-1.873l6.063-13.24v-6.508l-10.869-3.68a2.25 2.25 0 011.443-4.262l11.84 4.008c.134.045.26.102.38.169l.024-.009 12.314-4.168a2.25 2.25 0 111.443 4.263l-10.575 3.58v6.359l6.177 13.488z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.283 20.04c-.502-.18-.933-.365-1.283-.54l1.283.54c3.321 1.196 9.768 2.24 16.717-.54l-8.5 4-8.217-3.46z",
    fill: "#fff"
  })));
}
export default SvgAccessibility;